import { render, staticRenderFns } from "./AddNvrDialog.vue?vue&type=template&id=516d0923"
import script from "./AddNvrDialog.vue?vue&type=script&lang=js"
export * from "./AddNvrDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports